import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
import { deleteSessionItem, getSessionItem, setSessionItem } from '@atlassian/search-dialog';
import { fetchRelatedEntities, RelatedEntitiesResult, RelatedEntityType } from '../related-entities-api';
export var AI_TOPICS_CACHE_KEY = 'atlassian.search-dialog.ai-topics-component';
export var useRelatedTopics = function useRelatedTopics() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    aiRelatedTopics = _useState2[0],
    setAIRelatedTopics = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var fetchRelatedTopics = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var entityId, cloudId, principalEntityType, cache, _data$knowledgeDiscov, _yield$fetchRelatedEn, data, entities;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            entityId = _ref.entityId, cloudId = _ref.cloudId, principalEntityType = _ref.principalEntityType;
            if (entityId) {
              _context.next = 4;
              break;
            }
            setAIRelatedTopics([]);
            return _context.abrupt("return");
          case 4:
            cache = JSON.parse(getSessionItem(AI_TOPICS_CACHE_KEY) || '{}');
            if (!((cache === null || cache === void 0 ? void 0 : cache.entityId) === entityId)) {
              _context.next = 9;
              break;
            }
            setAIRelatedTopics(cache.topics);
            _context.next = 26;
            break;
          case 9:
            setAIRelatedTopics([]);
            deleteSessionItem(AI_TOPICS_CACHE_KEY);
            setIsLoading(true);
            _context.prev = 12;
            _context.next = 15;
            return fetchRelatedEntities({
              entityId: entityId,
              entityType: principalEntityType,
              relatedEntityType: RelatedEntityType.TOPIC,
              cloudId: cloudId,
              first: 5
            });
          case 15:
            _yield$fetchRelatedEn = _context.sent;
            data = _yield$fetchRelatedEn.data;
            if (data.knowledgeDiscovery.__typename === RelatedEntitiesResult.QueryError) {
              setError('REQUEST_ERROR');
            } else if ((_data$knowledgeDiscov = data.knowledgeDiscovery.relatedEntities) !== null && _data$knowledgeDiscov !== void 0 && _data$knowledgeDiscov.nodes) {
              entities = data.knowledgeDiscovery.relatedEntities.nodes;
              setAIRelatedTopics(entities);
              setSessionItem(AI_TOPICS_CACHE_KEY, JSON.stringify({
                entityId: entityId,
                topics: entities
              }));
            }
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](12);
            setError('NETWORK_ERROR');
          case 23:
            _context.prev = 23;
            setIsLoading(false);
            return _context.finish(23);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[12, 20, 23, 26]]);
    }));
    return function fetchRelatedTopics(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var resetTopics = useCallback(function () {
    setAIRelatedTopics([]);
  }, [setAIRelatedTopics]);
  var showTopics = !isLoading && !error && aiRelatedTopics.length > 0;
  return {
    aiRelatedTopics: aiRelatedTopics,
    fetchRelatedTopics: fetchRelatedTopics,
    showTopics: showTopics,
    resetTopics: resetTopics
  };
};